import React, { useState } from "react";
import "./Notifications.scss";
import { Checkbox, Collapse, Switch } from "antd";
import { useUser } from "contexts/UserContext";
import userApi from "services/UserApi";
import SearchSetting from "@components/SearchSetting/SearchSetting";

const Notifications: React.FC = () => {
  const { userProfile } = useUser();
  const hideEmail = (email: string) => {
    const [username, domain] = email.split("@");
    const usernameLength = username.length;
    //hide username except the first and last character
    const hiddenUsername =
      username[0] +
      "*".repeat(usernameLength - 2) +
      username[usernameLength - 1];
    return hiddenUsername + "@" + domain;
  };
  const [switchState, setSwitchState] = useState<boolean[]>(() => {
    const initialState = Array(7).fill(true, 1);
    initialState[0] = false;
    return initialState;
  });
  const [watchlistNotification, setWatchlistNotification] = useState(false);
  const handleSwitch = (index: number, checked: boolean) => {
    if (index === 0) {
      setSwitchState(switchState.fill(!checked, 1));
    }
    const updatedSwitchState = [...switchState];
    updatedSwitchState[index] = checked;
    setSwitchState(updatedSwitchState);
  };

  return (
    <div className="Notifications">
      <SearchSetting />
      <div className="title">
        Notifications{" "}
        <div className="switch">
          Mute All
          <Switch onChange={(checked) => handleSwitch(0, checked)} />
        </div>
      </div>
      <div className="sub-title">
        They will be sent to your email: {hideEmail(userProfile?.email ?? "")}
      </div>
      <div className="noti-group">
        <div className="noti-item">
          Communication (Private Messages){" "}
          <Switch
            onChange={(checked) => handleSwitch(1, checked)}
            checked={switchState[1]}
            disabled={switchState[0]}
          />
        </div>
        <Collapse
          activeKey={switchState[2] && !switchState[0] ? ["1"] : []}
          items={[
            {
              key: "1",
              label: (
                <div className="collapse-label">
                  Products{" "}
                  <Switch
                    onChange={(checked) => handleSwitch(2, checked)}
                    checked={switchState[2]}
                    disabled={switchState[0]}
                  />
                </div>
              ),
              children: switchState ? (
                <div className="collapse-children-group">
                  <div className="collapse-children-item">
                    Watchlist{" "}
                    <Checkbox
                      checked={watchlistNotification}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setWatchlistNotification(checked);
                        userApi.setWatchlistNotificationPreference(checked);
                      }}
                    />
                  </div>
                  <div className="collapse-children-item">
                    Recommended Products <Checkbox />
                  </div>
                  <div className="collapse-children-item">
                    New Listing Recommendations <Checkbox />
                  </div>
                </div>
              ) : null,
              showArrow: false,
            },
          ]}
        />
        <Collapse
          activeKey={switchState[3] && !switchState[0] ? ["1"] : ["0"]}
          items={[
            {
              key: "1",
              label: (
                <div className="collapse-label">
                  Orders{" "}
                  <Switch
                    onChange={(checked) => handleSwitch(3, checked)}
                    checked={switchState[3]}
                    disabled={switchState[0]}
                  />
                </div>
              ),
              children: switchState ? (
                <div className="collapse-children-group">
                  <div className="collapse-children-item">
                    Order Confirmation <Checkbox defaultChecked />
                  </div>
                  <div className="collapse-children-item">
                    Order Updates <Checkbox defaultChecked />
                  </div>
                </div>
              ) : null,
              showArrow: false,
            },
          ]}
        />
        <Collapse
          activeKey={switchState[4] && !switchState[0] ? ["1"] : ["0"]}
          items={[
            {
              key: "1",
              label: (
                <div className="collapse-label">
                  Billing{" "}
                  <Switch
                    onChange={(checked) => handleSwitch(4, checked)}
                    checked={switchState[4]}
                    disabled={switchState[0]}
                  />
                </div>
              ),
              children: switchState ? (
                <div className="collapse-children-group">
                  <div className="collapse-children-item">
                    Order Payments <Checkbox defaultChecked />
                  </div>
                  <div className="collapse-children-item">
                    Subscriptions <Checkbox />
                  </div>
                </div>
              ) : null,
              showArrow: false,
            },
          ]}
        />
        <div className="noti-item">
          (As a Consumer) Feedback Responses from Producers{" "}
          <Switch
            onChange={(checked) => handleSwitch(5, checked)}
            checked={switchState[5]}
            disabled={switchState[0]}
          />
        </div>
        <Collapse
          activeKey={switchState[6] && !switchState[0] ? ["1"] : ["0"]}
          items={[
            {
              key: "1",
              label: (
                <div className="collapse-label">
                  Producer Hub{" "}
                  <Switch
                    onChange={(checked) => handleSwitch(6, checked)}
                    checked={switchState[6]}
                    disabled={switchState[0]}
                  />
                </div>
              ),
              children: switchState ? (
                <div className="collapse-children-group">
                  <div className="collapse-children-item">
                    Consumer Reviews <Checkbox defaultChecked />
                  </div>
                  <div className="collapse-children-item">
                    Purchases from Consumers <Checkbox defaultChecked />
                  </div>
                  <div className="collapse-children-item">
                    Ranking Updates <Checkbox />
                  </div>
                  <div className="collapse-children-item">
                    Analytics <Checkbox />
                  </div>
                  <div className="collapse-children-item">
                    Achievements/Badges <Checkbox />
                  </div>
                </div>
              ) : null,
              showArrow: false,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default Notifications;
